import styled from 'styled-components';

export const NotAvailable = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #e6e6e6;
  color: #808080;
  font-size: 18px;
  font-weight: bold;
`;
